<template>
  <el-dialog
    title="详情"
    width="80%"
    v-bind="$attrs"
    :before-close="handleClose"
  >
    <template v-if="fileList.length>0">
      <el-card v-for="(item ,index) in fileList.filter(v=>!!v.pointList)" :key="index" class="box-card">
        <div slot="header" class="clearfix">
          <span>{{ item.fileName }}</span>
        </div>
        <div class="text item">
          <el-table
            v-if="item.pointList"
            :ref="'csv-table-'+index"
            :data="item.pointList"
            border
            :cell-class-name="setCellIndex"
            :row-class-name="tableRowClassName"
            @cell-dblclick="cellClick"
          >
            <el-table-column
              v-for="(title ,headerIndex) in item.tableHeader"
              :key="headerIndex"
              :label="title"
              align="center"
              width="100"
            >
              <template slot="header" slot-scope="scope">
                <div @mouseover="onMouseOver('refName' + scope.$index)">
                  <el-tooltip :disabled="isShowTooltip" :content="title" placement="top">
                    <div class="long_title">
                      <span :ref="'refName' + scope.$index">{{ title }}</span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
              <template v-slot="{ row }">
                {{ row[headerIndex] }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </template>
  </el-dialog>
</template>
<script>
import { getDetail } from '@/api/convert-csv'
export default {
  data() {
    return {
      fileList: [],
      isShowTooltip: true,
      highlightCellList: []
    }
  },
  computed: {
    visible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    init(x, y) {
      this.highlightCellList = []
      getDetail({ x: x, y: y }).then(res => {
        this.fileList = res
        this.$nextTick(() => {
          // this.addTableListener()
        })
      })
    },
    addTableListener() {
      if (this.fileList.length > 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          const bodyWrapper = this.$refs['csv-table-' + i][0].bodyWrapper
          bodyWrapper.addEventListener('scroll', () => {
            // 横滚
            for (let j = 0; j < this.fileList.length; j++) {
              if (i !== j) {
                const bodyWrapper1 = this.$refs['csv-table-' + j ][0].bodyWrapper
                if (bodyWrapper.scrollLeft + bodyWrapper1.clientWidth <= bodyWrapper1.scrollWidth) {
                  bodyWrapper1.scrollLeft = bodyWrapper.scrollLeft
                }
              }
            }
          })
        }
      }
    },
    removeTableListener() {
      if (this.fileList.length > 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          const bodyWrapper = this.$refs['csv-table-' + i][0].bodyWrapper
          bodyWrapper.removeEventListener('scroll')
        }
      }
    },
    handleClose() {
      this.visible = false
    },
    onMouseOver(refName) {
      const parentWidth = this.$refs[refName][0].parentNode.offsetWidth
      const contentWidth = this.$refs[refName][0].offsetWidth
      // 判断是否开启tooltip功能
      this.isShowTooltip = contentWidth <= parentWidth
    },
    tableRowClassName({ row, rowIndex }) {
      if (row[0] === '' || row[0] === 'Unit' || row[0] === 'LimitL' || row[0] === 'LimitU') {
        return 'warning-row'
      }
      return ''
    },
    cellClick(row, column, cell, event) {
      // const cellIndex = { row: row.home, column: column.home }
      // const indexOf = this.highlightCellList.findIndex(v => {
      //   return v.row === cellIndex.row && v.column === cellIndex.column
      // })
      // if (indexOf !== -1) {
      //   this.highlightCellList.splice(indexOf, 1)
      // } else {
      //   this.highlightCellList.push(cellIndex)
      // }
    },
    setCellIndex({ row, column, rowIndex, columnIndex }) {
      // row.home = rowIndex
      // column.home = columnIndex
      // const indexOf = this.highlightCellList.findIndex(v => {
      //   return v.row === rowIndex && v.column === columnIndex
      // })
      // if (indexOf !== -1) {
      //   return 'high-light-cell'
      // } else {
      //   return ''
      // }
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep {
  .el-table {
    .warning-row {
      background: lightgray;
    }
  }
}
.long_title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .high-light-cell{
  background-color: burlywood;
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.high-light-cell{
  background-color: burlywood!important;
}
::v-deep .el-table__body .el-table__row.high-light-cell.hover-row td {

}
</style>
